import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux'
import {Head} from "../../components";
import Container from "@mui/material/Container";
import IconButton from "@mui/material/IconButton";
import SyncIcon from '@mui/icons-material/Sync';
import {contentAction, treeAction} from "../../actions";
import {Box, Tooltip} from "@mui/material";
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import SortIcon from '@mui/icons-material/Sort';
import ReactPaginate from "react-paginate";
import moment from 'moment-jalaali'
import MenuItem from '@mui/material/MenuItem';
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionActions from '@mui/material/AccordionActions';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Autocomplete from '@mui/lab/Autocomplete';
import { UserAutocomplete} from './../../components'
import Chip from "@mui/material/Chip";
import Api from "../../utils/api";
import {toast} from "react-toastify";
import {Link, useLocation, useNavigate} from "react-router-dom";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import CreateIcon from "@mui/icons-material/Create";
import queryString from 'query-string';

const Contents = ( props ) => {
    const history = useNavigate();
    const location = useLocation();
    const query = queryString.parse(location.search);
    const { fetchEntities, contentReducer, fetchTreeCategory, treeReducer } = props;


    const [page, setPage] = useState(parseInt(query.page) || 1);
    const [sort_field, setSortField] = useState('id');
    const [sort_type, setSortType] = useState('desc');
    const [limit, setLimit] = useState(10);
    const [filter, setFilter] = useState({

    });

    const handleChangeSearchInput = (event) => {

        const modifiedQuery = {...query,[event.target.name]: event.target.value}
        for (const key of Object.keys(modifiedQuery)) {
            if (modifiedQuery[key] === "") {
                delete modifiedQuery[key];
            }
        }

        history(
            `${location.pathname}?${queryString.stringify(modifiedQuery)}`,
            { replace: true }
        );

        let search = filter;

        search[event.target.name] = event.target.value;

        setFilter({...search})

    }

    const handleChangeSearchInputWithAutoComplete = (name, value) => {

        let search = filter;

        search[name] = value;

        setFilter({...search})

    }

    useEffect(() => {
        fetchTreeCategory()
    }, [])


    useEffect(() => {
        handleRequest();
    }, [sort_field, sort_type, limit, page, filter]);


    const handleRequest = () => {
        const modifiedQuery = {...query,["page"]: page}
        for (const key of Object.keys(modifiedQuery)) {
            if (modifiedQuery[key] === "") {
                delete modifiedQuery[key];
            }
        }
        history(
            `${location.pathname}?${queryString.stringify(modifiedQuery)}`,
            { replace: true }
        );
        fetchEntities({
            filter,
            sort_field: sort_field,
            sort_type: sort_type,
            page: page,
            limit: limit
        })
    };



    const handleChangeStatus = (id, field) => {
        new Api().put('/blog/' + id + '/status', {field}, false).then((response) => {
            if (typeof response !== "undefined") {
                if (response.status) {
                    handleRequest()
                } else {
                    toast.error(response.msg);
                }
            }
        })
    }


    const pageCount = Math.ceil(parseInt(contentReducer?.entities.total) / parseInt(contentReducer?.entities.per_page));

    return(
        <div style={{ padding: '0 20px'}}>
            <Head data={{ 'link': '/', 'title': 'مدیریت محتوا', 'description': 'کلیه محتوای موجود در سایت را مدیریت نمایید.' }} />
            <Box style={{ margin: '20px 0'}} boxShadow={0}>
                <Accordion defaultExpanded={false}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1c-content"
                        id="panel1c-header"
                    >
                        <div>
                            <Typography >جستجو</Typography>
                        </div>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={4} md={3} >
                                <TextField
                                    id="outlined-name"
                                    label="شناسه"
                                    variant="outlined"
                                    margin='dense'
                                    fullWidth
                                    name='id'
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onChange={handleChangeSearchInput}
                                    value={query.id}

                                />
                            </Grid>
                            <Grid item xs={12} sm={4} md={3} >
                                <TextField
                                    id="outlined-name"
                                    label="عنوان"
                                    variant="outlined"
                                    margin='dense'
                                    fullWidth
                                    name='title'
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onChange={handleChangeSearchInput}
                                    value={query.title}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4} md={3}>
                                <UserAutocomplete label={'اپراتور'} onChange={(value) => handleChangeSearchInputWithAutoComplete('created_by', value)}/>
                            </Grid>
                            <Grid item xs={12} sm={4} md={3} >
                                <TextField
                                    select
                                    label="وضعیت"
                                    variant="outlined"
                                    value={filter.status}
                                    margin='dense'
                                    fullWidth
                                    name='status'
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onChange={handleChangeSearchInput}
                                >
                                    <MenuItem key={0} value={-1}>انتخاب</MenuItem>
                                    <MenuItem key={1} value={1}>فعال</MenuItem>
                                    <MenuItem key={2} value={0}>غیرفعال</MenuItem>
                                </TextField>
                            </Grid>
                            <Grid item xs={12} sm={4} md={3} >
                                <TextField
                                    select
                                    label="نمایش در وبلاگ"
                                    variant="outlined"
                                    value={filter.is_blog}
                                    margin='dense'
                                    fullWidth
                                    name='is_blog'
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onChange={handleChangeSearchInput}
                                >
                                    <MenuItem key={0} value={-1}>انتخاب</MenuItem>
                                    <MenuItem key={1} value={1}>بله</MenuItem>
                                    <MenuItem key={2} value={0}>خیر</MenuItem>
                                </TextField>
                            </Grid>
                            <Grid item xs={12} sm={4} md={3} >
                                <TextField
                                    select
                                    label="نمایش در پنل کاربر"
                                    variant="outlined"
                                    value={filter.is_private}
                                    margin='dense'
                                    fullWidth
                                    name='is_private'
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onChange={handleChangeSearchInput}
                                >
                                    <MenuItem key={0} value={-1}>انتخاب</MenuItem>
                                    <MenuItem key={1} value={1}>بله</MenuItem>
                                    <MenuItem key={2} value={0}>خیر</MenuItem>
                                </TextField>
                            </Grid>
                            {/*<Grid item xs={12} sm={4} md={3} >*/}
                            {/*    <TextField*/}
                            {/*        select*/}
                            {/*        label="نمایش پاپ آپ"*/}
                            {/*        variant="outlined"*/}
                            {/*        value={filter.is_popup}*/}
                            {/*        margin='dense'*/}
                            {/*        fullWidth*/}
                            {/*        name='is_popup'*/}
                            {/*        InputLabelProps={{*/}
                            {/*            shrink: true,*/}
                            {/*        }}*/}
                            {/*        onChange={handleChangeSearchInput}*/}
                            {/*    >*/}
                            {/*        <MenuItem key={0} value={-1}>انتخاب</MenuItem>*/}
                            {/*        <MenuItem key={1} value={1}>بله</MenuItem>*/}
                            {/*        <MenuItem key={2} value={0}>خیر</MenuItem>*/}
                            {/*    </TextField>*/}
                            {/*</Grid>*/}
                            <Grid item xs={12} sm={4} md={3} >
                                <Autocomplete
                                    onChange={((event, value) => handleChangeSearchInputWithAutoComplete('category_id', (value ? value.id : '') ))}
                                    options={treeReducer.nodes}
                                    getOptionLabel={(option) => option.title}
                                    renderInput={(params) =>
                                        <TextField
                                            {...params}
                                            fullWidth
                                            name='category_id'
                                            margin={"dense"}
                                            label="بخش"
                                            variant="outlined"
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                    }
                                />
                            </Grid>
                        </Grid>
                    </AccordionDetails>
                    <Divider />
                    <AccordionActions>
                        <Button size="small" color="primary">
                            جستجو
                        </Button>
                    </AccordionActions>
                </Accordion>
            </Box>
            <Box mb={2}>
                <Grid container alignItems="center" >
                    <Grid item xs={4} sm={6}>
                        <TextField
                            select
                            value={limit}
                            margin='dense'
                            InputLabelProps={{
                                shrink: true,
                            }}
                            onChange={(event) => setLimit(event.target.value)}
                        >
                            <MenuItem  value="10">10</MenuItem>
                            <MenuItem  value="20">20</MenuItem>
                            <MenuItem  value="30">30</MenuItem>
                            <MenuItem  value="50">50</MenuItem>
                            <MenuItem  value="100">100</MenuItem>
                            <MenuItem  value="200">200</MenuItem>
                        </TextField>
                    </Grid>
                    <Grid item xs={8} sm={6}>
                        <ReactPaginate
                            previousLabel={'<'}
                            nextLabel={'>'}
                            breakLabel={'...'}
                            pageCount={pageCount}
                            marginPagesDisplayed={2}
                            pageRangeDisplayed={5}
                            onPageChange={(selectedItem) => setPage(selectedItem.selected + 1)}
                            containerClassName={'pagination'}
                            activeClassName={'active'}
                        />
                    </Grid>
                </Grid>
            </Box>
            <div style={{ display: 'flex', direction: 'row', justifyContent: 'flex-end'}}>
                <Tooltip title="افزودن">
                    <Link to={'/blog/updateOrCreate'}>
                        <IconButton>
                            <AddCircleOutlineIcon />
                        </IconButton>
                    </Link>
                </Tooltip>
                <Tooltip title="سینک" onClick={() => handleRequest()}>
                    <IconButton>
                        <SyncIcon />
                    </IconButton>
                </Tooltip>
            </div>
            <>
                <div style={{ overflowX: 'auto'}}>
                    <table className='table'>
                        <thead>
                        <tr>
                            <th onClick={() => {setSortField('id'); setSortType(sort_type === 'asc' ? 'desc' : 'asc')}}>#&nbsp;{ sort_field === 'id' ? (sort_type === 'desc'  ? <ArrowDownwardIcon /> : <ArrowUpwardIcon />) : <SortIcon />}</th>
                            <th onClick={() => {setSortField('created_by'); setSortType(sort_type === 'asc' ? 'desc' : 'asc')}}>اپراتور&nbsp;{sort_field === 'created_by' ? (sort_type === 'desc'  ? <ArrowDownwardIcon /> : <ArrowUpwardIcon />) : <SortIcon />}</th>
                            <th onClick={() => {setSortField('title'); setSortType(sort_type === 'asc' ? 'desc' : 'asc')}}>عنوان&nbsp;{sort_field === 'title' ? (sort_type === 'desc'  ? <ArrowDownwardIcon /> : <ArrowUpwardIcon />) : <SortIcon />}</th>
                            <th onClick={() => {setSortField('is_blog'); setSortType(sort_type === 'asc' ? 'desc' : 'asc')}}>نمایش در وبلاگ&nbsp;{sort_field === 'is_blog' ? (sort_type === 'desc'  ? <ArrowDownwardIcon /> : <ArrowUpwardIcon />) : <SortIcon />}</th>
                            <th onClick={() => {setSortField('is_private'); setSortType(sort_type === 'asc' ? 'desc' : 'asc')}}>نمایش خصوصی&nbsp;{sort_field === 'is_private' ? (sort_type === 'desc'  ? <ArrowDownwardIcon /> : <ArrowUpwardIcon />) : <SortIcon />}</th>
                            {/*<th onClick={() => {setSortField('is_popup'); setSortType(sort_type === 'asc' ? 'desc' : 'asc')}}>نمایش پاپ آپ&nbsp;{sort_field === 'is_popup' ? (sort_type === 'desc'  ? <ArrowDownwardIcon /> : <ArrowUpwardIcon />) : <SortIcon />}</th>*/}
                            <th onClick={() => {setSortField('created_at'); setSortType(sort_type === 'asc' ? 'desc' : 'asc')}}>تاریخ ایجاد&nbsp;{sort_field === 'created_at' ? (sort_type === 'desc'  ? <ArrowDownwardIcon /> : <ArrowUpwardIcon />) : <SortIcon />}</th>
                            <th onClick={() => {setSortField('updated_at'); setSortType(sort_type === 'asc' ? 'desc' : 'asc')}}>به روز رسانی&nbsp;{sort_field === 'updated_at' ? (sort_type === 'desc'  ? <ArrowDownwardIcon /> : <ArrowUpwardIcon />) : <SortIcon />}</th>
                            <th onClick={() => {setSortField('status'); setSortType(sort_type === 'asc' ? 'desc' : 'asc')}}>وضعیت&nbsp;{sort_field === 'status' ? (sort_type === 'desc' ? <ArrowDownwardIcon/> : <ArrowUpwardIcon/>) : <SortIcon/>}</th>
                            <th>عملیات</th>
                        </tr>
                        </thead>
                        <tbody>
                        {contentReducer.entities.data && contentReducer.entities.data.map((entity, index) => {
                            return(
                                <tr key={index}>
                                    <td>{entity.id}</td>
                                    <td>{entity.created_by && entity.created_by.name + ' ' + entity.created_by.family}</td>
                                    <td>{entity.title}</td>
                                    <td>{contentReducer.flag && contentReducer.flag[entity.is_blog]}</td>
                                    <td>{contentReducer.flag && contentReducer.flag[entity.is_private]}</td>
                                    {/*<td>{contentReducer.flag && contentReducer.flag[entity.is_popup]}</td>*/}
                                    <td style={{ direction: 'ltr'}}>{moment(entity.created_at, 'YYYY/MM/DD HH:mm:ss').locale('fa').format('jYYYY/jMM/jDD HH:mm:ss')}</td>
                                    <td style={{ direction: 'ltr'}}>{moment(entity.updated_at, 'YYYY/MM/DD HH:mm:ss').locale('fa').format('jYYYY/jMM/jDD HH:mm:ss')}</td>
                                    <td>
                                        <Tooltip title="وضعیت">
                                            <Chip size={"small"} variant={"outlined"} color={+entity.status === 1 ? "primary": "secondary"}  label={+entity.status === 1 ? 'فعال' : 'غیرفعال'} clickable={true} onClick={() => handleChangeStatus(entity.id, 'status')} />
                                        </Tooltip>
                                    </td>
                                    <td>
                                        <Tooltip title="ویرایش">
                                            <Link to={`/blog/updateOrCreate/${entity.id}/${entity.title}`}>
                                                <IconButton>
                                                    <CreateIcon />
                                                </IconButton>
                                            </Link>
                                        </Tooltip>
                                    </td>
                                </tr>
                            );
                        })}
                        </tbody>
                    </table>
                </div>
                <ReactPaginate
                    previousLabel={'<'}
                    nextLabel={'>'}
                    breakLabel={'...'}
                    pageCount={pageCount}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={5}
                    onPageChange={(selectedItem) => setPage(selectedItem.selected + 1)}
                    containerClassName={'pagination'}
                    activeClassName={'active'}
                />
            </>
        </div>

    );
}


const mapStateToProps = state => ({
    contentReducer: state.contentReducer,
    treeReducer: state.treeReducer

});

const mapDispatchToProps = (dispatch) => ({
    fetchTreeCategory: () => {
        dispatch(treeAction.blogCategories())
    },
    fetchEntities: (object) => {
        dispatch(contentAction.contents(object))
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(Contents)
